<app-menu #appMenu [isShowSearch]="false"></app-menu>

<div class="container" *ngIf="!isLoading; else loading">
    <div class="checkout-form">

        <section class="checkout-section">
            <h2>Endereço de entrega</h2>
            <form [formGroup]="addressForm">


                <div class="form-row">
                    <mat-form-field appearance="outline">
                        <mat-label>CEP</mat-label>
                        <input matInput formControlName="deliveryZipcode" placeholder="00000-000"
                            (blur)="onCepChange($event)" mask="00000-000">
                        <mat-spinner matSuffix *ngIf="isSearchingCep" diameter="18"></mat-spinner>
                        <mat-error *ngIf="addressForm.get('deliveryZipcode')?.hasError('required')">CEP é
                            obrigatório</mat-error>
                        <mat-error *ngIf="addressForm.get('deliveryZipcode')?.hasError('minlength')">CEP deve
                            conter 8 dígitos</mat-error>
                        <mat-error *ngIf="addressForm.get('deliveryZipcode')?.hasError('cepInvalido')">CEP inválido
                            ou não encontrado nos Correios</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Endereço</mat-label>
                        <input matInput formControlName="deliveryAddress" maxlength="60">
                        <mat-error *ngIf="addressForm.get('deliveryAddress')?.hasError('required')">Endereço é
                            obrigatório</mat-error>
                        <mat-error *ngIf="addressForm.get('deliveryAddress')?.hasError('minlength')">Endereço deve
                            ter no mínimo 2 caracteres</mat-error>
                        <mat-error *ngIf="addressForm.get('deliveryAddress')?.hasError('maxlength')">Endereço deve
                            ter no máximo 60 caracteres</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Número</mat-label>
                        <input matInput formControlName="deliveryNumber" maxlength="10">
                        <mat-error *ngIf="addressForm.get('deliveryNumber')?.hasError('required')">Número é
                            obrigatório</mat-error>
                        <mat-error *ngIf="addressForm.get('deliveryNumber')?.hasError('maxlength')">Número deve
                            ter no máximo 10 caracteres</mat-error>
                    </mat-form-field>
                </div>

                <div class="form-row">
                    <mat-form-field appearance="outline" class="flex-1">
                        <mat-label>Bairro</mat-label>
                        <input matInput formControlName="deliveryNeighborhood" maxlength="60">
                        <mat-error *ngIf="addressForm.get('deliveryNeighborhood')?.hasError('required')">Bairro é
                            obrigatório</mat-error>
                        <mat-error *ngIf="addressForm.get('deliveryNeighborhood')?.hasError('minlength')">Bairro deve
                            ter no mínimo 2 caracteres</mat-error>
                        <mat-error *ngIf="addressForm.get('deliveryNeighborhood')?.hasError('maxlength')">Bairro deve
                            ter no máximo 60 caracteres</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="flex-1">
                        <mat-label>Complemento</mat-label>
                        <input matInput formControlName="deliveryComplement" maxlength="60">
                        <mat-error *ngIf="addressForm.get('deliveryComplement')?.hasError('maxlength')">Complemento deve
                            ter no máximo 60 caracteres</mat-error>
                    </mat-form-field>

                </div>

                <div class="form-row">
                    <mat-form-field appearance="outline">
                        <mat-label>Cidade</mat-label>
                        <input matInput formControlName="deliveryCity" maxlength="60">
                        <mat-error *ngIf="addressForm.get('deliveryCity')?.hasError('required')">Cidade é
                            obrigatória</mat-error>
                        <mat-error *ngIf="addressForm.get('deliveryCity')?.hasError('minlength')">Cidade deve
                            ter no mínimo 2 caracteres</mat-error>
                        <mat-error *ngIf="addressForm.get('deliveryCity')?.hasError('maxlength')">Cidade deve
                            ter no máximo 60 caracteres</mat-error>
                    </mat-form-field>
                    <!-- <mat-form-field appearance="outline">
                        <mat-label>Estado</mat-label>
                        <input matInput formControlName="deliveryState">
                        <mat-error *ngIf="addressForm.get('deliveryState')?.hasError('required')">Estado é
                            obrigatório</mat-error>
                    </mat-form-field> -->
                    <mat-form-field appearance="outline">
                        <mat-label>Estado</mat-label>
                        <mat-select formControlName="deliveryState">
                            <mat-option *ngFor="let estado of estados" [value]="estado.sigla">
                                {{ estado.nome }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="addressForm.get('deliveryState')?.hasError('required')">
                            Estado é obrigatório
                        </mat-error>
                    </mat-form-field>
                </div>


                <div class="shipping-options"
                    *ngIf="shoppingCartData != undefined && shoppingCartData.listCorreios?.length">
                    <h3>Escolha o frete</h3>
                    <mat-radio-group [(ngModel)]="selectedShippingOption" [ngModelOptions]="{standalone: true}"
                        (change)="changeShipping()">
                        <mat-radio-button *ngFor="let option of shoppingCartData.listCorreios"
                            [value]="option.serviceCode"
                            [disabled]="option.isDisabledDueToWeight">
                            <b>{{ option.serviceName }}</b>
                            <ng-container *ngIf="!option.isDisabledDueToWeight">
                                {{ option.price | currency:'BRL'}} em {{option.estimadeDays}} dias
                            </ng-container>
                            <ng-container *ngIf="option.isDisabledDueToWeight">
                                <span class="shipping-weight-warning">
                                    — Indisponível: o peso do pedido ({{ option.weightKg | number:'1.2-2' }}kg) excede o limite de {{ option.weightLimitKg }}kg desta modalidade
                                </span>
                            </ng-container>
                        </mat-radio-button>
                    </mat-radio-group>

                    <div class="shipping-blocked-banner" *ngIf="allShippingOptionsBlocked">
                        <p>
                            <b>O peso total do pedido ({{ totalCartWeightKg | number:'1.2-2' }}kg) excede o limite das modalidades de entrega disponíveis.</b><br>
                            Para continuar, reduza a quantidade de livros ou divida a compra em pedidos separados.
                        </p>
                    </div>
                </div>


            </form>
        </section>

        <section class="checkout-section">
            <h2>Pagamento</h2>

            <mat-radio-group [(ngModel)]="paymentMethod" (change)="onPaymentMethodChange($event.value)">
                <mat-radio-button value="creditCard" checked>Cartão de crédito</mat-radio-button>
                <mat-radio-button value="pix">PIX</mat-radio-button>
            </mat-radio-group>

            <form [formGroup]="paymentForm" *ngIf="paymentMethod === 'creditCard'">
                <h3>Informações do cartão</h3>

                <div class="form-row">
                    <mat-form-field appearance="outline">
                        <mat-label>Nome impresso no cartão</mat-label>
                        <input matInput formControlName="cardName">
                        <mat-error *ngIf="paymentForm.get('cardName')?.hasError('required')">Nome é
                            obrigatório</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Número do cartão</mat-label>
                        <input matInput formControlName="cardNumber" mask="0000 0000 0000 0000">
                        <mat-error *ngIf="paymentForm.get('cardNumber')?.hasError('required')">Número do cartão é
                            obrigatório</mat-error>
                    </mat-form-field>
                </div>

                <div class="form-row">
                    <mat-form-field appearance="outline">
                        <mat-label>MM/AA</mat-label>
                        <input matInput formControlName="expiryDate" mask="00/00">
                        <mat-error *ngIf="paymentForm.get('expiryDate')?.hasError('required')">Validade é
                            obrigatória</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>CVC</mat-label>
                        <input matInput formControlName="cvc" type="text" maxlength="4">
                        <mat-error *ngIf="paymentForm.get('cvc')?.hasError('required')">CVC é obrigatório</mat-error>
                    </mat-form-field>
                </div>
                @if(shoppingCartData.listPaymentMethodInstallment){
                <div class="form-row">
                    <mat-form-field appearance="outline">
                        <mat-label>Parcelas</mat-label>
                        <mat-select formControlName="idPaymentMethodInstallment"
                            (selectionChange)="changePaymentMethodInstallment()">
                            <mat-option *ngFor="let item of shoppingCartData.listPaymentMethodInstallment"
                                [value]="item.idPaymentMethodInstallment">
                                {{ getInstallmentLabel(item) }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                }
                <h3>Informações do titular do cartão</h3>
                <div class="form-row">
                    <mat-form-field appearance="outline">
                        <mat-label>Nome do titular</mat-label>
                        <input matInput formControlName="name" type="text">
                        <mat-error *ngIf="paymentForm.get('name')?.hasError('required')">Nome do titular do cartão é
                            obrigatório</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>CPF</mat-label>
                        <input matInput formControlName="cpf" mask="000.000.000-00">
                        <mat-error *ngIf="paymentForm.get('cpf')?.invalid">Informe um CPF
                            válido</mat-error>
                    </mat-form-field>
                </div>

                <div class="form-row">
                    <mat-form-field appearance="outline">
                        <mat-label>E-mail do titular</mat-label>
                        <input matInput formControlName="email" type="text">
                        <mat-error *ngIf="paymentForm.get('email')?.hasError('required')">Email do titular do cartão é
                            obrigatório</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>CEP</mat-label>
                        <input matInput formControlName="postalCode" type="text" mask="00000-000"
                            placeholder="00000-000">
                        <mat-error *ngIf="paymentForm.get('postalCode')?.hasError('required')">CEP do titular do cartão
                            é
                            obrigatório</mat-error>
                    </mat-form-field>
                </div>

                <div class="form-row">
                    <mat-form-field appearance="outline">
                        <mat-label>Número do endereço</mat-label>
                        <input matInput formControlName="addressNumber" type="text">
                        <mat-error *ngIf="paymentForm.get('addressNumber')?.hasError('required')">Número do titular do
                            cartão é obrigatório</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Complemento</mat-label>
                        <input matInput formControlName="addressComplement" type="text">
                        <mat-error *ngIf="paymentForm.get('addressComplement')?.hasError('required')">Complemento do
                            titular do cartão é obrigatório</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Celular</mat-label>
                        <input matInput formControlName="mobilePhone" type="text" mask="(00) 00000-0000">
                        <mat-error *ngIf="paymentForm.get('mobilePhone')?.hasError('required')">Celular do titular do
                            cartão é
                            obrigatório</mat-error>
                    </mat-form-field>
                </div>
            </form>

            <form [formGroup]="paymentPixForm" *ngIf="paymentMethod === 'pix'">
                <div class="pix-info">
                    <p>O QR Code para pagamento será gerado após a finalização da compra.</p>
                </div>
                <mat-form-field appearance="outline">
                    <mat-label>CPF do titular que irá realiar o PIX</mat-label>
                    <input matInput formControlName="cpfPix" type="text" mask="000.000.000-00">
                    <mat-error *ngIf="paymentPixForm.get('cpfPix')?.invalid">Informe um CPF
                        válido</mat-error>
                </mat-form-field>
            </form>

        </section>

        <div class="summary-items">
            <h2>Resumo</h2>

            <app-kit-payment-book *ngFor="let item of shoppingCartData.listShoppingCart" [book]="item"
                (quantityChange)="onQuantityChange($event)" (applyDiscount)="onApplyDiscount($event)">
            </app-kit-payment-book>

            <div class="summary-totals">
                <div class="summary-updating" *ngIf="hasPendingQuantityUpdate">
                    <mat-spinner diameter="16"></mat-spinner>
                    <span>Atualizando valores...</span>
                </div>
                <div class="total-line">
                    <span>Total</span>
                    <span>{{ subtotal.toFixed(2) | currency: 'BRL'}}</span>
                </div>
                <div class="total-line">
                    <span>Desconto do autor</span>
                    <span>- {{ totalAuthorDiscount.toFixed(2) | currency: 'BRL'}}</span>
                </div>
                <div class="total-line">
                    <span>Frete</span>
                    <span>{{ totalShipping.toFixed(2)| currency: 'BRL' }}</span>
                </div>
                <div class="total-line">
                    <span>Juros</span>
                    <span>{{ juros.toFixed(2)| currency: 'BRL' }}</span>
                </div>
                <div class="total-line final-total">
                    <span>Total</span>
                    <span>{{ finalTotal + juros | currency: 'BRL'}}</span>
                </div>
            </div>

            <button mat-flat-button class="btn-primary finalize-button" [disabled]="allShippingOptionsBlocked || hasPendingQuantityUpdate || isSearchingCep" (click)="onSubmit()">Finalizar compra</button>
        </div>

    </div>

</div>

<ng-template #loading>
    <div class="loading-spinner">
        <mat-spinner></mat-spinner>
    </div>
</ng-template>

<app-footer></app-footer>